<script lang="ts">
export default {
  name: 'AccountRenewalView',
};
</script>

<script setup lang="ts">
import { accountService } from '@/services/api';
import { groupedProgramRates, ProgramRateGroup } from '@/types/ProgramRates';
import Renewals from '@/components/Renewals.vue';
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import Skeleton from '@/components/v2/Skeleton.vue';
import { Account } from '@/types/Account.js';

const loading = ref<boolean>(false);
let groups = ref<ProgramRateGroup[]>([]);
const account = ref<Account>();

const accountId = computed(() => useRoute().params.id as string);

onMounted(async () => {
  if (loading.value) return;
  loading.value = true;

  account.value = await accountService.findById(accountId.value);
  const results = await accountService.getProgramRates(accountId.value);
  groups.value = groupedProgramRates(results);

  loading.value = false;
});
</script>

<template>
  <div class="px-8 py-4">
    <Renewals v-if="!loading" :account-id="accountId" :account-name="account?.displayName ?? account?.accountName" :program-rate-groups="groups" />

    <div v-else class="space-y-2">
      <Skeleton v-for="i in 4" :key="i" shape="rectangle" width="100%" height="48px" class="rounded-md" />
    </div>
  </div>
</template>